
import React from 'react';
import { Card, CardHeader, CardContent, CardFooter, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface TariffInfoErrorProps {
  error: string;
}

export const TariffInfoError = ({ error }: TariffInfoErrorProps) => (
  <Card className="w-full bg-card/80 shadow-md">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2 text-amber-500">
        <AlertTriangle className="h-5 w-5" /> 
        Ошибка загрузки
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-muted-foreground">{error}</p>
    </CardContent>
    <CardFooter>
      <Button 
        className="w-full" 
        variant="outline" 
        onClick={() => window.location.reload()}
      >
        Повторить загрузку
      </Button>
    </CardFooter>
  </Card>
);
